"use client";
import React, { useState } from "react";
import { FmButton } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import ColorComfirmDrawer from "./ColorComfirmDrawer";

interface Props {}

const ColorComfirmBtn: React.FC<Props> = (props) => {
    const [isShowColorSelect, setIsShowColorSelect] = useState(false);
    const { t } = useTranslation(["common", "productDetail"]);
    const showColorPanel = () => {
        setIsShowColorSelect(true);
    };

    return (
        <>
            <FmButton size="medium" onClick={showColorPanel}>
                {t("productDetail:SelectLenses")}
            </FmButton>
            <ColorComfirmDrawer
                open={isShowColorSelect}
                onClose={(open) => setIsShowColorSelect(open)}
            />
        </>
    );
};

export default ColorComfirmBtn;
